import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // 1. Import useLocation

const MaintenanceGuard = ({ children }) => {
  const [isBlocked, setIsBlocked] = useState(false);
  const [timeLeft, setTimeLeft] = useState("");
  const location = useLocation(); // 2. Get current path

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const currentHour = now.getHours();
      
      // Define block: 6:00 PM (18:00) to 6:00 AM (06:00)
      const isMaintenanceTime = currentHour >= 18 || currentHour < 6;
      
      // 3. Logic: Block ONLY if it's maintenance time AND NOT an admin route
      const isAdminRoute = location.pathname.toLowerCase().startsWith('/admin');
      
      setIsBlocked(isMaintenanceTime && !isAdminRoute);

      if (isMaintenanceTime) {
        // Calculate time until 6:00 AM tomorrow
        let openingTime = new Date();
        if (currentHour >= 18) openingTime.setDate(openingTime.getDate() + 1);
        openingTime.setHours(6, 0, 0, 0);

        const diff = openingTime - now;
        const h = Math.floor(diff / (1000 * 60 * 60));
        const m = Math.floor((diff / (1000 * 60)) % 60);
        const s = Math.floor((diff / 1000) % 60);
        setTimeLeft(`${h}h ${m}m ${s}s`);
      }
    };

    const timer = setInterval(checkTime, 1000);
    checkTime(); 
    return () => clearInterval(timer);
  }, [location.pathname]); // 4. Re-check when route changes

  if (isBlocked) {
    return (
      <div style={{
        height: '100vh', width: '100vw', backgroundColor: '#fff',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', padding: '20px', textAlign: 'center',
        fontFamily: 'sans-serif', position: 'fixed', top: 0, left: 0, zIndex: 9999
      }}>
        <img src="/logo2.jpeg" style={{ width: '80px', marginBottom: '20px' }} alt="LP Logo" />
        <h2 style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: '24px' }}>PORTAL TEMPORARILY CLOSED</h2>
        
        <div style={{ maxWidth: '650px', margin: '20px 0', lineHeight: '1.6', color: '#333', fontSize: '15px' }}>
            <p><strong>TEMPORARY CLOSURE OF THE E-MEMBERSHIP REGISTRATION PORTAL</strong></p>
            <p>The Labour Party (LP) E-Membership Portal is closed for essential system updates and data harmonisation until <b>6:00 AM tomorrow</b>.</p>
            <p style={{ fontSize: '0.85rem', color: '#666', borderTop: '1px solid #eee', paddingTop: '10px' }}>
              Pursuant to Section 77(5) of the Electoral Act 2026.
            </p>
        </div>
        
        <div style={{ backgroundColor: '#f1f8f1', padding: '25px', borderRadius: '15px', border: '2px solid #088d01' }}>
          <p style={{ margin: '0 0 5px 0', fontSize: '12px', color: '#088d01', fontWeight: 'bold' }}>REOPENING IN:</p>
          <h1 style={{ margin: 0, color: '#000', letterSpacing: '3px', fontFamily: 'monospace' }}>{timeLeft}</h1>
        </div>

        <div style={{ marginTop: '40px' }}>
         
          <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>Labour Party (LP)</p>
        </div>
      </div>
    );
  }

  return children;
};

export default MaintenanceGuard;